// src/app/redux/sagas/campagnesSaga.js
import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    fetchCampagnesSuccess,
    fetchCampagnesFail,

    fetchVisibleCampagnesSuccess,
    fetchVisibleCampagnesFail,

    createCampagneSuccess,
    createCampagneFail,

    updateCampagneSuccess,
    updateCampagneFail,

    deleteCampagneSuccess,
    deleteCampagneFail,

    setCampagnesLoading, fetchBudgetByCampagneFail, fetchBudgetByCampagneSuccess,
} from "../actions/campagnesActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

// ===== Helpers =====
const toastOk = (text) =>
    Swal.fire({ icon: "success", text, timer: 1400, showConfirmButton: false });
const toastErr = (text) =>
    Swal.fire({ icon: "error", text, timer: 2200, showConfirmButton: false });

// ===== Workers =====
export function* fetchCampagnesSaga() {
    const url = `${API_BASE_URL}/api/campagnes`;
    const uid = getUid();
    const token = getToken();

    yield put(setCampagnesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchCampagnesSuccess(resp.data));
    } catch (e) {
        yield put(fetchCampagnesFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setCampagnesLoading(false));
    }
}
export function* fetchBudgetByCampagneSaga(action) {
    const { campagneId  } = action.payload;

    const url = `${API_BASE_URL}/api/campagnes/budget/${campagneId}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCampagnesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchBudgetByCampagneSuccess(resp.data));
    } catch (e) {
        yield put(fetchBudgetByCampagneFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setCampagnesLoading(false));
    }
}

export function* fetchVisibleCampagnesSaga() {
    const url = `${API_BASE_URL}/api/campagnes/visible`;
    const uid = getUid();
    const token = getToken();

    yield put(setCampagnesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchVisibleCampagnesSuccess(resp.data));
    } catch (e) {
        yield put(fetchVisibleCampagnesFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setCampagnesLoading(false));
    }
}

export function* createCampagneSaga(action) {
    const url = `${API_BASE_URL}/api/campagnes`;
    const uid = getUid();
    const token = getToken();

    yield put(setCampagnesLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload, uid, token });
        yield put(createCampagneSuccess(resp.data));
        yield call(toastOk, "Campagne ajoutée");
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur ajout campagne";
        yield put(createCampagneFail(msg));
        yield call(toastErr, msg);
    } finally {
        yield put(setCampagnesLoading(false));
    }
}

export function* updateCampagneSaga(action) {
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/campagnes/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCampagnesLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid, token });
        yield put(updateCampagneSuccess(resp.data));
        yield call(toastOk, "Campagne modifiée");
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur modification campagne";
        yield put(updateCampagneFail(msg));
        yield call(toastErr, msg);
    } finally {
        yield put(setCampagnesLoading(false));
    }
}

export function* deleteCampagneSaga(action) {
    const { id } = action.payload;
    const url = `${API_BASE_URL}/api/campagnes/${id}`;
    const uid = getUid();
    const token = getToken();

    yield put(setCampagnesLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteCampagneSuccess(id));
        yield call(toastOk, "Campagne supprimée");
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression campagne";
        yield put(deleteCampagneFail(msg));
        yield call(toastErr, msg);
    } finally {
        yield put(setCampagnesLoading(false));
    }
}

// ===== Watcher =====
export default function* campagnesWatcher() {

}
